import { BaseNode } from "../mvc/base/base-node";
import { Transition } from "../mvc/transition";
import { DiagnosticSeverity, IdentifiableDiagnostic, ValidatorService } from "../services/validation-service";
import RappidContext from "./rappid-context";
import { debounce } from "lodash-es";
import { ModelEventBus } from "../../event-bus";

export default class ValidationController {
  constructor(
    private context: RappidContext,
    private validatorService: ValidatorService
  ) {}

  private isDragging = false;

  activate() {
    this.context.paper.on("cell:pointerdown", this.dragging);
    this.context.paper.on("cell:pointerup", this.release);
    this.context.paper.on("element:pointerdown", this.dragging);
    this.context.paper.on("element:pointerup", this.release);

    ModelEventBus.on("modelLoaded", this.triggerValidation.bind(this));
    ModelEventBus.on("modelChanged", this.triggerValidation.bind(this));
    ModelEventBus.on("modelValidated", (diagnostics) => {
      this.applyValidationResult(diagnostics);
    });
  }

  triggerValidation() {
    if (!this.isDragging) {
      this.validatorService.validate();
    }
  }

  applyValidationResult(diagnostics: Array<IdentifiableDiagnostic>) {
    this.context.graph.getCells().forEach((cell) => {
      if (!(cell instanceof BaseNode || cell instanceof Transition)) return;
      if (cell.errors === undefined || cell.warnings === undefined) return;

      const cellErrors = diagnostics.filter(
        (diagnostic) => diagnostic.elementId === cell.id && diagnostic.severity === DiagnosticSeverity.ERROR
      );
      const cellWarnings = diagnostics.filter(
        (diagnostic) => diagnostic.elementId === cell.id && diagnostic.severity === DiagnosticSeverity.WARNING
      );

      const view = this.context.paper.findViewByModel(cell);
      this.context.controllers.get(view)?.on("cell:validation", { errors: cellErrors, warnings: cellWarnings });
    });
  }

  private dragging = () => {
    this.isDragging = true;
  };

  private release = () => {
    this.isDragging = false;
  };
}
